"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { formatDay, isToday } from "@/lib/date-utils";
import { SwipeContainer } from "@/components/ui/swipe-container";

interface DayNavigatorProps {
  currentDate: Date;
  onPreviousDay: () => void;
  onNextDay: () => void;
}

export function DayNavigator({
  currentDate,
  onPreviousDay,
  onNextDay,
}: DayNavigatorProps) {
  const isTodaySelected = isToday(currentDate);

  return (
    <SwipeContainer
      onSwipeRight={onPreviousDay}
      onSwipeLeft={isTodaySelected ? undefined : onNextDay}
      disableSwipeLeft={isTodaySelected}
    >
      <div className="flex items-center justify-between py-2">
        <Button variant="ghost" size="icon" onClick={onPreviousDay}>
          <ChevronLeft className="w-5 h-5" />
          <span className="sr-only">Previous day</span>
        </Button>
        <div className="text-center">
          <p className="font-medium">{formatDay(currentDate)}</p>
          <p className="text-sm text-muted-foreground">
            {isTodaySelected ? "Today" : format(currentDate, "yyyy")}
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={onNextDay}
          disabled={isTodaySelected}
        >
          <ChevronRight className="w-5 h-5" />
          <span className="sr-only">Next day</span>
        </Button>
      </div>
    </SwipeContainer>
  );
}
